import { useState } from "react";
import {
  Button,
  Box,
  Popover,
  Stack,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { ChevronDown } from "./icons";

export default function PopoverField({
  label,
  required = false,
  value = "",
  children,
  width = "target",
}) {
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);

  return (
    <Popover
      opened={opened}
      position="bottom-start"
      width={width}
      shadow="md"
      zIndex={1000}
      withinPortal={false}
      styles={{
        dropdown: {
          backgroundColor: "#fff",
        },
      }}
    >
      <Popover.Target>
        <Box
          onClick={() => setOpened((o) => !o)}
          style={{
            cursor: "pointer",
            borderBottom: "1px solid white",
            color: "white",
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "space-between",
            width: "100%",
            paddingBottom: 10,
          }}
        >
          <Box>
            <Text
              size="md"
              fw={600}
              style={{ color: "#ffffff", marginBottom: 8 }}
            >
              {label}
              {required && <span style={{ color: "#ff6b6b" }}> *</span>}
            </Text>

            <Box
              style={{
                minHeight: 26,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Text style={{ fontSize: 14, fontWeight: 500, opacity: 0.7 }}>
                {value}
              </Text>
            </Box>
          </Box>

          <ChevronDown
            style={{ color: theme.colors.primary[0] }}
            width={15}
            height={15}
          />
        </Box>
      </Popover.Target>

      <Popover.Dropdown>
        <Stack gap="md">
          {children}

          <Button
            style={{ background: "#1f312c" }}
            onClick={() => setOpened(false)}
          >
            Done
          </Button>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
}
